var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 21,
  viewBox: "0 0 24 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.045.5C.154.2.44 0 .758 0h22.484a.758.758 0 0 1 .658 1.136L12.784 20.618a.758.758 0 0 1-1.402-.234L9.159 8.759.273 1.342A.76.76 0 0 1 .045.501M10.7 8.743l1.786 9.34L21.216 2.78zm9.666-7.224H2.85L9.935 7.43z"
})));
export default SvgInstagramMobileSend;